import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 园区后台用户模块
 */

export const A_User = {
    // 获取园区权限列表
    modifyPassword(parmas, expend) {
        return send("POST", "/api/company/user/password", parmas, expend);
    },
    // 获取人脸用户信息用于绑定到系统用户
    getFaceUserList(parmas, expend) {
        return send("GET", "/api/company/face/users", parmas, expend);
    },
}